import type { Dossier, SearchProvider } from "./types";
import { FIXTURE_DOSSIER } from "./fixtures";

const delay = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

/**
 * M1: Stage 1 대신 고정 후보를 돌려준다.
 * 나중에 BisemSearchProvider로 교체해도 UI는 바뀌지 않는다.
 */
export class FixtureSearchProvider implements SearchProvider {
  async search(query: string, _epoch: number): Promise<Dossier> {
    await delay(35);
    return { ...FIXTURE_DOSSIER, query };
  }
}
